import { styled } from '@mui/material';

export const WebhookFormContainer = styled('div')(() => ({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
}));

export const WebhookFormHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
}));

export const WebhookStepContainer = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  display: 'flex',
  flexGrow: 1,
  alignSelf: 'center',
  padding: theme.spacing(4, 3, 0),
  maxWidth: '100%',
  width: theme.width.content,
  boxSizing: 'border-box',
}));

export const WebhookFormFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  alignSelf: 'center',
  padding: theme.spacing(3),
  gap: theme.spacing(1),
  maxWidth: '100%',
  width: theme.width.content,
  boxSizing: 'border-box',
}));
